import * as React from "react";
import { Typography, Button, Select, Checkbox } from "antd";
import SelectInput from "../../app/SelectInput";
import { IReportingPeriodItem } from "../../../../model/report/ReportingPeriodItem";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { IReport1Applicant } from "../../../../model/report/Report1Applicant";
import { IFormTypeItem } from "../../../../model/report/FormTypeItem";
import { IFormVersionItem } from "../../../../model/report/FormVersionItem";
import { DateService } from "../../../../service/DateService";
const { Option } = Select;

export interface State {
  selectedApplicants: number[];
}
export interface Props {
  currentReportingPeriod?: IReportingPeriodItem;
  reportingPeriodList: IReportingPeriodItem[];
  onChangeReportingPeriod(reportingPeriodId: number): void;
  applicants: IReport1Applicant[];
  currentApplicant?: IReport1Applicant;
  onChangeApplicant(applicantId: number): void;
  formTypes: IFormTypeItem[];
  currentFormType?: IFormTypeItem;
  onChangeFormType(formTypeId: number): void;
  onChangeFormVersion(formTypeId: number): void;
  currentFormVersion?: IFormVersionItem;
  formVersionList?: IFormVersionItem[];
  getPDFReport: any;
  translate: TTranslate;
  loading?: boolean;
  title?: string;
  onChangeIncludePublic(e: any): void;
  includePublic?: boolean;
  onApplicantSearch(fullName: string): void;
}

export default class Report1ParamsBox extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { ...props, selectedApplicants: [] };
  }

  setSelectedApplicants(id: number) {
    const { selectedApplicants } = this.state;
    let newSelectedApplicants: number[] = [];
    if (selectedApplicants.includes(id)) {
      newSelectedApplicants = selectedApplicants.filter(
        (selected) => selected !== id
      );
    } else {
      newSelectedApplicants = ([] as any[]).concat(id);
    }
    this.setState({ selectedApplicants: newSelectedApplicants });
  }
  render() {
    const {
      currentReportingPeriod,
      reportingPeriodList,
      onChangeReportingPeriod,
      applicants,
      getPDFReport,
      translate,
      loading,
      title,
      currentApplicant,
      onChangeApplicant,
      formTypes,
      currentFormType,
      onChangeFormType,
      onChangeIncludePublic,
      includePublic,
      onChangeFormVersion,
      currentFormVersion,
      formVersionList,
      onApplicantSearch
    } = this.props;
    return (
      <div className={"report-sidebar"}>
        <div className={"report-param-title"}>
          <Typography.Title style={{ fontSize: 14 }}>{title}</Typography.Title>
          <SelectInput
            value={currentReportingPeriod?.id.toString()}
            placeholder={translate("report1.choose_reporting_type")}
            selectOptions={reportingPeriodList}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            style={{ width: "100%" }}
            onChange={(e) => {
              onChangeReportingPeriod(parseInt(e, 10));
            }}
            showSearch={true}
            defaultActiveFirstOption={false}
            notFoundContent={translate("search.no_data")}
          />
          <div style={{ marginTop: 20 }}>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("report1.applicant")}
            </Typography.Title>
            <SelectInput
              value={currentApplicant?.id.toString()}
              placeholder={translate("report1.applicant_placeholder")}
              selectOptions={applicants}
              selectOptionKey={"id"}
              selectOptionValue={"fullName"}
              style={{ width: "100%" }}
              onChange={(e) => {
                onChangeApplicant(parseInt(e, 10));
              }}
              defaultActiveFirstOption={false}
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              onSearch={(value) => onApplicantSearch(value)}
            />
          </div>
          <div style={{ marginTop: 20 }}>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("report1.form_types")}
            </Typography.Title>
            <SelectInput
              disabled={currentReportingPeriod ? false : true}
              value={currentFormType?.name}
              placeholder={translate("report1.choose_form_type")}
              selectOptions={formTypes}
              selectOptionKey={"id"}
              selectOptionValue={"name"}
              style={{ width: "100%" }}
              onChange={(e) => onChangeFormType(e)}
              defaultActiveFirstOption={false}
              showSearch={true}
              notFoundContent={translate("search.no_data")}
            />
          </div>
          <div style={{ marginTop: 20 }}>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("report1.form_versions")}
            </Typography.Title>
            <Select
              optionFilterProp={"label"}
              showSearch={true}
              value={currentFormVersion?.version.toString()}
              placeholder={translate("report1.choose_form_version")}
              allowClear={true}
              disabled={
                currentApplicant && currentFormType && currentReportingPeriod
                  ? false
                  : true
              }
              style={{ width: "100%" }}
              onChange={(e) => {
                onChangeFormVersion(e);
              }}
              defaultActiveFirstOption={false}
              notFoundContent={translate("search.no_data")}
            >
              {formVersionList?.map((item: IFormVersionItem) => (
                <Option key={item["id"]} label={item["version"]}>
                  <span style={{ fontSize: 14 }}>{`${item.version} (${
                    item.status
                  }), ${DateService().formatDate(item.dateSent)}, ${
                    item.basisForSending
                  } `}</span>
                  <span style={{ fontSize: 12 }}>
                    {item.forPublish
                      ? `\n ${
                          item.regularEvaluationStatus
                            ? item.regularEvaluationStatus
                            : ` `
                        } Objavljen ${DateService().formatDate(
                          item.datePublished
                        )}`
                      : `${item.regularEvaluationStatus} Nije za objavu`}
                  </span>
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ marginTop: 20 }}>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("report1.include_public")}
            </Typography.Title>
            <Checkbox
              defaultChecked={includePublic}
              onChange={(e) => {
                onChangeIncludePublic(e);
              }}
            ></Checkbox>
          </div>
        </div>

        <Button
          className={"report-btn"}
          type="primary"
          onClick={() => getPDFReport()}
          loading={loading}
          disabled={
            currentReportingPeriod &&
            currentApplicant &&
            currentFormType &&
            currentFormVersion
              ? false
              : true
          }
        >
          {translate("reports.show")}
        </Button>
      </div>
    );
  }
}
